<template>
  <div class="site-wrapper">
    <Header />
    <main>
      <div class="home-wrapper">
        <h1>NUDE PÅ NÄTET - STATISTIK</h1>
        <router-link :to="{ name: 'contact' }">
          <g-button>Kontaktmetoder-statistik</g-button>
        </router-link>
        <router-link :to="{ name: 'story' }">
          <g-button>Story-statistik</g-button>
        </router-link>
      </div>
    </main>
    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue';
import Header from '@/components/Header.vue';
export default {
  components: {
    Footer,
    Header
  }
};
</script>

<style lang="scss" scoped>
.home-wrapper {
  margin: 0 auto 60px;
  max-width: $content-max-width;
}

h1 {
  margin-bottom: 40px;
}
</style>
